import { QUOTA_VERIFY, QUOTAS_FETCH, QUOTAS_FETCH_SUCCESS } from './constants'

export const quotasFetch = payload => ({ payload, type: QUOTAS_FETCH })
export const quotasFetchSuccess = payload => ({ payload, type: QUOTAS_FETCH_SUCCESS })
export const quotaVerify = payload => ({ payload, type: QUOTA_VERIFY })
